export const isIncludedInOrderingList = (item, orderingList) =>
    orderingList && item && orderingList.find(assay => assay && assay.id === item.id && assay.type === item.type);
